import { createFileRoute } from "@tanstack/react-router";
import UsageDashboardPage from "src/components/app/UsageDashboardPage/UsageDashboardPage";
import { preloadLazyModule } from "src/lib/LazyModules";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { hasUsageCharts } from "src/lib/UsageChartUtils";
import { getUsagePageData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/usage")({
  // The charts' code (recharts) loads with the page's data when it has a chart to draw, so the
  // charts render with the document; accounts without usage never download it.
  loader: async (context) => {
    const result = await projectLoader((projectId) => getUsagePageData({ data: projectId }))(
      context,
    );
    const usage = result.data?.initialDashboardData?.usage;
    if (result.status === "pending" || (usage && hasUsageCharts(usage))) {
      await preloadLazyModule("usageChart");
    }
    return result;
  },
  component: UsagePage,
});

function UsagePage() {
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => <UsageDashboardPage initialDashboardData={data?.initialDashboardData} />}
    </DeferredLoaderData>
  );
}
